import type { LaravelPaginationResponse } from '@/interfaces/models/Laravel'
import type {
	EmailDownload,
	EmailDownloadModel,
	EmailDownloadSelection,
	EmailDownloadStorePayload,
	EmailDownloadTemplate,
	SharedDownload,
} from './Model'
import Api from '@/helpers/models/Api'
import type { AxiosResponse } from 'axios'
import axios from 'axios'

const apiUrl = import.meta.env.VITE_API_URL

export default class EmailDownloadsApi extends Api<
	EmailDownloadModel,
	LaravelPaginationResponse<EmailDownloadModel>,
	EmailDownloadStorePayload
> {
	route = 'email-downloads'

	async update(): Promise<any> {
		throw new Error('Not implemented')
	}

	async updateRelation(): Promise<any> {
		throw new Error('Not implemented')
	}

	async destroy(): Promise<any> {
		throw new Error('Not implemented')
	}

	async template(selection: EmailDownloadSelection): Promise<AxiosResponse<EmailDownloadTemplate>> {
		return await axios.get(`${apiUrl}/${this.route}/template`, { params: selection })
	}

	async retry(id: EmailDownload['id']): Promise<AxiosResponse<EmailDownload>> {
		return await axios.post(`${apiUrl}/${this.route}/${id}/retry`)
	}

	async resend(id: EmailDownload['id']): Promise<AxiosResponse<EmailDownload>> {
		return await axios.post(`${apiUrl}/${this.route}/${id}/resend`)
	}

	async revoke(id: EmailDownload['id']): Promise<AxiosResponse<EmailDownload>> {
		return await axios.post(`${apiUrl}/${this.route}/${id}/revoke`)
	}

	async preview(token: string): Promise<AxiosResponse<SharedDownload>> {
		return await axios.post(`${apiUrl}/shared-downloads/preview`, { token })
	}

	async download(token: string): Promise<AxiosResponse<Blob>> {
		return await axios.post(
			`${apiUrl}/shared-downloads/download`,
			{ token },
			{ responseType: 'blob' },
		)
	}
}
